module.exports = __webpack_public_path__ + "static/img/lujing.3c28e16a.png";